module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_bucketpl_m.a53f830dc5da8a140236039eb4fe9a4d.png";